export var FMealDrinkTypeEnum;
(function (FMealDrinkTypeEnum) {
    FMealDrinkTypeEnum["aperitif"] = "APERITIF";
    FMealDrinkTypeEnum["wine"] = "WINE";
    FMealDrinkTypeEnum["digestive"] = "DIGESTIVE";
})(FMealDrinkTypeEnum || (FMealDrinkTypeEnum = {}));
